import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import noop from '@anm/helpers/noop';
import { AlertText } from '@anm/styles/helpers';
import { useCallback, useMemo, useState, FC } from 'react';

export type AlertName = 'free_user' | 'long_duration';
export type DuplicateVideoAlertProps = {
  onClose?(): void;
};

export const FREE_USER = 'free_user';
export const LONG_DURATION = 'long_duration';

const DuplicateVideoAlert: FC<DuplicateVideoAlertProps> = ({ children, onClose = noop }) => (
  <Dialog onModalClose={onClose} onSubmit={onClose}>
    <AlertBlock onButtonClick={onClose}>
      <AlertText>{children}</AlertText>
    </AlertBlock>
  </Dialog>
);

const getAlert = (alertName: AlertName) => {
  switch (alertName) {
    case FREE_USER:
      return 'Please upgrade to duplicate videos.';
    case LONG_DURATION:
      return 'Cannot duplicate videos longer than 30 minutes.';
  }
};

export const useDuplicateVideoAlert = () => {
  const [alertName, setAlertName] = useState<AlertName | null>(null);
  const closeAlert = useCallback(() => setAlertName(null), []);
  const message = alertName ? getAlert(alertName) : null;

  const renderAlert = useMemo(
    () => message && <DuplicateVideoAlert onClose={closeAlert}>{message}</DuplicateVideoAlert>,

    [message]
  );

  return [renderAlert, setAlertName] as const;
};
